import WebApi from "@/views/loyalty/shared/modules/web_api"

export class JustpayFiscalEndpointService {
    constructor () {
        this.url = `${process.env.VUE_APP_JUSTPAY_URL}api/fiscal/`
        this.webApi = new WebApi()
    }

    async getList (arg) {
        const fiscals = await this.webApi.post(`${this.url}list`, arg)
        // console.log('fiscals:', fiscals)
        if (fiscals) {
            if (!fiscals.status_code) {
                if (!fiscals.error) {
                    return fiscals
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${fiscals.status_code}`)
            }
        }
        return null
    }

    async getForFiltering () {
        const fiscals = await this.webApi.get(`${this.url}GetForFiltering`)
        // console.log('fiscals:', fiscals)
        if (fiscals) {
            if (!fiscals.status_code) {
                if (!fiscals.error) {
                    return fiscals
                } else {
                    return null
                }
            } else {
                console.error(`Ошибка с кодом: ${fiscals.status_code}`)
            }
        }
        return null
    }
}
